var map = {
	"./athens.jpg": 879,
	"./berlin.jpg": 571,
	"./bucharest.jpg": 614,
	"./oslo.jpg": 530,
	"./paris.jpg": 846,
	"./russia.jpg": 30,
	"./sankt-petersburg.jpg": 91,
	"./sofia.jpg": 514,
	"./tivat.jpg": 971,
	"./vienna.jpg": 770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 360;